// Utilitarios para Google Analytics e Google Ads
// IDs de configuracao
export const GA_MEASUREMENT_ID = 'G-QY1T1E8Z8P';
export const GOOGLE_ADS_ID = 'AW-16951315097';

// Funcao para enviar eventos personalizados
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, {
      ...parameters,
    });
  }
};

// Eventos especificos de conversao
export const trackFormSubmission = (formType: 'contact' | 'newsletter' | 'quote') => {
  trackEvent('form_submission', {
    form_type: formType,
    event_category: 'engagement',
    event_label: formType,
  });
};

export const trackWhatsAppClick = (source: 'footer' | 'floating_button' | 'contact_page' | 'service_page') => {
  trackEvent('whatsapp_click', {
    source: source,
    event_category: 'engagement',
    event_label: 'whatsapp_contact',
  });
};

export const trackPhoneClick = (source: string) => {
  trackEvent('phone_click', {
    source: source,
    event_category: 'engagement',
    event_label: 'phone_contact',
  });
};

export const trackEmailClick = (source: string) => {
  trackEvent('email_click', {
    source: source,
    event_category: 'engagement',
    event_label: 'email_contact',
  });
};

export const trackServiceView = (serviceName: string) => {
  trackEvent('service_view', {
    service_name: serviceName,
    event_category: 'content',
    event_label: serviceName,
  });
};

export const trackPageView = (pageName: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_title: pageName,
      page_location: window.location.href,
    });
  }
};

// Funcao para configurar conversoes personalizadas
export const trackCustomConversion = (conversionLabel: string, value?: number) => {
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: `${GOOGLE_ADS_ID}/${conversionLabel}`,
      value: value || 1.0,
      currency: 'BRL',
    });
  }
}; 



